import React, { useState } from 'react';

import { Container, Row, Col } from 'reactstrap';
import aboutImg from '../../images/meto2.png'
import './about.css';
import Education from './Education';
import Skills from './Skills';
// import Portfolio from './Portfolio';

const About = () => {

    const [aboutFilter, setAboutFilter] = useState('ABOUT');
    const [showFullDescription, setShowFullDescription] = useState(false);
    const shortDescription = "I come from Western Burundi, a region in East Africa known for Mukeke and Ndagara. I am a creative person who loves to explore new ideas and concepts.";
    const fullDescription = "I come from Western Burundi, a region in East Africa known for Mukeke and Ndagara.  I am a creative person who loves to explore new ideas and concepts.  Teaching computer programming is one of my passions, as I find it to be an exciting and enjoyable experience. Although my career did not originally involve teaching programming,  I am grateful for the path it has taken me on. I am looking forward to what the future holds  and am excited to continue learning and growing in this field. Being able to share knowledge and ideas with others is one of the most rewarding aspects of teaching.  It is a privilege to have a diverse network of individuals, supporters, friends, and affiliates from all  around the world. In my free time, I enjoy exploring my interests in computers, reading, building bots, and cyber security.  I am always eager to learn more and improve my skills in these areas. Thank you for taking the time to read my description. I look forward to discussing how I can contribute my  skills and knowledge to our team and organization.";


    const toggleDescription = () => {
        setShowFullDescription(!showFullDescription);
    }

  return (
    <section id='about'>
        <Container>
            <Row>
                <Col lg='12' className='mb-5'>
                    <h2>About Me</h2>
                </Col>

                <Col lg='4' md='3'>
                    <div className="about-btns d-flex flex-column align-items-center">
                        <button className={`about-btn ${aboutFilter === 'ABOUT' ? 'about-btn__active': ''}`} onClick={()=>setAboutFilter('ABOUT')}>About me</button>
                        <button className={`about-btn ${aboutFilter === 'EDUCATION' ? 'about-btn__active': ''}`} onClick={()=>setAboutFilter('EDUCATION')}>My Education</button>
                        <button className={`about-btn ${aboutFilter === 'SKILLS' ? 'about-btn__active': ''}`} onClick={()=>setAboutFilter('SKILLS')}>My Skills</button>
                        {/* <button className={`about-btn ${aboutFilter === 'PORTFOLIO' ? 'about-btn__active': ''}`} onClick={()=>setAboutFilter('PORTFOLIO')}>My Projects</button> */}
                    </div>
                </Col>

                <Col lg='8' md='9'>
                    {
                        aboutFilter === 'ABOUT' && <div className="about-content__wrapper d-flex gap-5">
                        <div className="about-img w-25">
                            <img src={aboutImg} alt="My Pic" className="w-100" />
                        </div>
                        <div className="about-content w-75">
                            <h2>I'm Landry SAWA INGABIRE</h2>
                            <p>
                            {showFullDescription ? fullDescription : shortDescription}
                            <br />
                            <button onClick={toggleDescription}>
                                {showFullDescription ? "Minimize" : "Read More..."}
                            </button>
                            </p>
                            <div className="social-links">
                                <h6  className='mb-3'>Connect with me on:</h6>
                                <span><a href="https://www.facebook.com/landry.ingabire.3"><i className="ri-facebook-line"></i></a></span>
                                <span><a href="https://twitter.com/BryanPior?t=1PX33V-48bDut9yUfDuqJQ&s=09"><i className="ri-twitter-line"></i></a></span>
                                <span><a href="https://www.instagram.com/khamincardnl"><i className="ri-instagram-line"></i></a></span>
                                <span><a href="https://www.github.com/sawalandry"><i className="ri-github-line"></i></a></span>
                                <span><a href="https://www.linkedin.com/in/ingabire-sawa-landry-01a75423a"><i className="ri-linkedin-line"></i></a></span>
                            </div>
                        </div>
                        </div>
                    }

                    {
                        aboutFilter === 'EDUCATION' && <Education />
                    }

                    {
                        aboutFilter === 'SKILLS' && <Skills />
                    }

                    {/* {
                        aboutFilter === 'PORTFOLIO' && <Portfolio />
                    } */}
                </Col>
            </Row>
        </Container>
    </section>
  )
}

export default About